import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchPreviousHistory } from "../../../redux/actions/historyAction";
import { useHistory } from "react-router-dom";

const REACT_APP_IMAGE_DIR = process.env.REACT_APP_IMAGE_DIR;

function SingleBanner() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");

  const handleOnSubmit = (e) => {
    e.preventDefault();

    dispatch(fetchPreviousHistory("/landing"));

    history.push(`/search?keyword=${searchText}`);
  };

  const handleOnChange = (e) => {
    setSearchText(e.target.value);
  };

  const [style, setStyle] = useState({
    imgStyle: {
      //backgroundImage: 'url("/images/calepa_hq.jpg")',
      // backgroundImage: 'url("/images/cdt-banner.jpg")',
      backgroundImage: `url("${REACT_APP_IMAGE_DIR}/banner/landing-page-map.jpg")`,
      height: "35vh",
      //maxHeight: "50vh",
      maxHeight: "35vh",
      backgroundPosition: "top",
      paddingTop: "100px",
      // borderTop: "5px solid #FDB81E",
      borderBottom: "5px solid #FDB81E",
      //marginTop: "100px",
    },
    zIndex: { zIndex: "99" },
  });

  return (
    <div
      className="header-single-banner"
      role="img"
      aria-label="Map"
      style={style.imgStyle}
    >
      <div id="head-search" className="landing featured-search">
        <div className="landing-search-container">
          <form onSubmit={handleOnSubmit}>
            <div className="input-group">
              <input
                type="text"
                name="p_searchtext"
                className="landing-search"
                onChange={handleOnChange}
                placeholder="Search by ID Number or Handler Name"
                aria-label="Search by ID Number or Handler Name"
                aria-describedby="basic-addon2"
              />
              <div className="input-group-append">
                <button className="btn-landing-search" type="submit">
                  <span className="ca-gov-icon-search landing-search-icon">
                    <span className="sr-only">Search</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SingleBanner;
